import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { getBattlebotSlotCenterPixels } from '../components/BattlebotPortalOverlay';
import './QuantumSurgeRefreshEffect.css';

/**
 * Expanding cyan ripples on the targeted unit slot (Quantum Surge refresh).
 */
export function QuantumSurgeRefreshEffect({ viewerSlot, animationKey }) {
  const [center, setCenter] = useState(null);

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!viewerSlot?.zone || viewerSlot.index == null) {
        if (!cancelled) setCenter(null);
        return;
      }
      const pt = getBattlebotSlotCenterPixels(viewerSlot.zone, viewerSlot.index);
      if (pt) {
        if (!cancelled) setCenter(pt);
        return;
      }
      if (attempt < 18 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setCenter(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [viewerSlot, animationKey]);

  if (!center) {
    return null;
  }

  const layer = (
    <div
      className="quantum-surge-refresh-root"
      aria-hidden
      data-animation-key={animationKey}
      style={{
        left: `${center.x}px`,
        top: `${center.y}px`,
        transform: 'translate(-50%, -50%)',
      }}
    >
      <div className="quantum-surge-refresh-ripples">
        <span className="quantum-surge-refresh-ripple quantum-surge-refresh-ripple--1" />
        <span className="quantum-surge-refresh-ripple quantum-surge-refresh-ripple--2" />
        <span className="quantum-surge-refresh-ripple quantum-surge-refresh-ripple--3" />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default QuantumSurgeRefreshEffect;
